export default [
  {
    path: 'offers',
    component: () => import('./Offers'),
    children: [
      {
        path: '/',
        component: () => import('./OffersList'),
        name: 'offersList'
      },
      {
        path: 'add',
        component: () => import('./OfferForm'),
        name: 'addOffer'
      },
      {
        path: ':id',
        component: () => import('./OfferForm'),
        name: 'editOffer'
      }
    ]
  }
]
